import { ReactElement } from 'react';

import { Cell, CellText } from '@hh.ru/magritte-ui-cell';
import { AdditionalDefault } from '@hh.ru/magritte-ui-tree-selector/collection/types';
import { RenderItemProps } from '@hh.ru/magritte-ui-tree-selector/types';

export const TreeSelectorItemBase = <Additional extends AdditionalDefault>({
    disabled,
    input,
    item,
    isXS,
    labelRight,
}: RenderItemProps<Additional>): ReactElement => {
    const cellProps = {
        [isXS ? 'right' : 'left']: input,
        ...(isXS && labelRight && { right: labelRight }),
    };
    return (
        <Cell disabled={disabled} {...cellProps} Element={isXS || !input ? 'div' : 'label'} align="top">
            <CellText data-qa={`tree-selector-item-text tree-selector-item-text-${item.id}`}>{item.text}</CellText>
        </Cell>
    );
};
